export const NOTIFICATION_SEND = 'NOTIFICATION_SEND';
export const NOTIFICATION_DISMISS = 'NOTIFICATION_DISMISS';
export const NOTIFICATION_UPDATE = 'NOTIFICATION_UPDATE';
export const NOTIFICATION_CLEAR = 'NOTIFICATION_CLEAR';
export const NOTIFICATION_CLOSE = 'NOTIFICATION_CLOSE';

/**
 * Publish a notification,
 * - if `dismissAfter` was set, the notification will be auto dismissed after the given period.
 * - if id wasn't specified, a time based id will be generated.``
 */
export function notify(notif) {
  const payload = Object.assign({}, notif);
  if (!payload.id && !notif.key) {
    payload.id = new Date().getTime();
  }else if(notif.key){
    payload.id = notif.key;
  }
  return dispatch => {
    
    dispatch({ type: NOTIFICATION_SEND, payload });
	
    /*if (payload.dismissAfter) {
      setTimeout(() => {
        dispatch({
          type: NOTIFICATION_DISMISS,
          payload: payload.id,
        });
      }, payload.dismissAfter);
    }*/
  };
}

/**
 * Dismiss a notification by the given id.
 */
export function notifyDismiss(id) {
  return { type: NOTIFICATION_DISMISS, payload: id };
}

/**
 * Dismiss a notification by the given id.
 */
export function notifyClose(id) {
  return { type: NOTIFICATION_CLOSE, payload: id };
}

/**
 * Dismiss a notification by the given id.
 */
export function notifyUpdate(id, notifFn) {
	const payload = Object.assign({}, {id:id, fn:notifFn});
	return dispatch => {
		dispatch( { type: NOTIFICATION_UPDATE, payload  });
  };
}

/**
 * Clear all notifications
 */
export function notifyClear() {
  return { type: NOTIFICATION_CLEAR };
}